<template>
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <!--添加门店-->
      <div class="common-form">修改问题信息</div>
      <el-form-item label="问题标题">
        <el-input v-model="form.problem_title" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="问题内容">
        <el-input v-model="form.problem_content" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="问题类型">
        <el-input v-model="form.problem_type" type="number" class="max-w460"></el-input>
        <div class="tips">问题类型（1常见问题，2、支付问题，3、设备维修，4、租赁保障）</div>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper"><el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button></div>
    </el-form>
  </div>
</template>

<script>
import SettingApi from '@/api/setting.js';

export default {
  data() {
    return {
      /*切换菜单*/
      // activeIndex: '1',
      /*form表单数据*/
      form: {
        problem_title: '',
        problem_content: '',
        problem_type:'',
        id:''
      },
      loading: false
    };
  },
  created() {
    this.getData();
    
  },
  
  mounted() {
    this.form.problem_title = this.$route.query.title;
    this.form.problem_content = this.$route.query.content;
    this.form.problem_type = this.$route.query.type;
    this.form.id = this.$route.query.id;
	},
  methods: {
    /*获取数据*/
    getData() {
      let self = this;
      // 取到路由带过来的参数
      const params = this.$route.query.id;
      SettingApi.questionEdit(
        {
          id: params
        },
        true
      )
        .then(data => {
          let detail = data.data.detail;
          // 将数据放在当前组件的数据内
          // self.form.problem_title = detail.problem_title;
          // self.form.problem_content = detail.problem_content;
          // self.form.problem_type = detail.problem_type;
        })
        .catch(error => {});
    },

    /*提交表单*/
    onSubmit() {
      let self = this;
      self.loading = true;
      let params = this.form;
      SettingApi.questionEdit(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '恭喜你，修改成功',
            type: 'success'
          });
          self.$router.push('/problem/problem/index');
        })
        .catch(error => {
          self.loading = false;
        });
    },
    
  }
};
</script>

<style>
.tips {
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/problem/problem/edit.vue